import { render } from "./KpisRenderer.vue?vue&type=template&id=3cf7b780&scoped=true"
import script from "./KpisRenderer.vue?vue&type=script&lang=js"
export * from "./KpisRenderer.vue?vue&type=script&lang=js"

import "./KpisRenderer.vue?vue&type=style&index=0&id=3cf7b780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf7b780"]])

export default __exports__